











































































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { DataTable, Col } from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'
import { OrderSelection } from '@/api'

const COLS: Col[] = [
  {
    width: '26',
    resizable: true,
    items: [
      {
        name: 'displayMemo',
        headerText: '発注リスト名'
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'selectionBranch',
        headerText: '選定館'
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'orderNumber',
        headerText: '発注数',
        align: 'right'
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'callNo',
        headerText: '請求記号'
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'shelfType',
        headerText: '配架区分'
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'collectionType',
        headerText: '資料区分'
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'handlingType',
        headerText: '取扱区分'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'editingSystemUserId',
        headerText: '編集状況'
      }
    ]
  }
]

@Component({
  components: {
    RecycleScroller,
    DataTable
  }
})
export default class SelectionInfoTable extends DataTable {
  @Prop({
    type: Array,
    required: true
  })
  tableItems!: OrderSelection[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  get showCols(): Col[] {
    return COLS
  }

  @Emit('link')
  onClickLink(orderCardId: number): number {
    return orderCardId
  }
}
